import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface FeatureItemProps {
  icon: string;
  title: string;
  description: string;
}

const FeatureItem = ({ icon, title, description }: FeatureItemProps) => {
  return (
    <div className="flex gap-4">
      <div className="flex-shrink-0 w-10 h-10 bg-brand-primary/10 rounded-lg flex items-center justify-center">
        <Icon name={icon as any} size={20} className="text-brand-primary" />
      </div>
      <div>
        <h4 className="text-lg font-semibold text-text-primary mb-2">{title}</h4>
        <p className="text-text-secondary leading-relaxed">{description}</p>
      </div>
    </div>);

};

interface ProgramOverviewProps {
  className?: string;
}

const ProgramOverview = ({ className = '' }: ProgramOverviewProps) => {
  const features: FeatureItemProps[] = [
  {
    icon: 'CpuChipIcon',
    title: 'Duration: 28 Weeks',
    description: 'Flexible curriculum with add-on modules for up to 28 weeks of content. Great for in-class instruction or auxiliary programming.'
  },
  {
    icon: 'AcademicCapIcon',
    title: 'Grade Levels: K–12',
    description: 'Three curricula designed for age-appropriate learning experiences.'
  },
  {
    icon: 'CubeIcon',
    title: 'Full Kit Included',
    description: 'Modular vertical farm, 1 year curriculum license, 1 year of growing supplies, student build kits, and 1 month of virtual support.'
  },
  {
    icon: 'HeartIcon',
    title: 'Real Food, Real Impact',
    description: 'Programs turn schools into hubs that provide fresh food for their community and equip students with high-demand technical skills.'
  }];


  return (
    <section className={`py-20 bg-background ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center px-3 py-1 bg-accent/10 rounded-full mb-6">
              <span className="text-sm font-semibold text-accent">Program Overview</span>
            </div>

            <h2 className="text-3xl sm:text-4xl font-bold text-text-primary mb-6">
              Transforming Education Through Innovation
            </h2>

            <p className="text-lg text-text-secondary mb-8 leading-relaxed">
              Farms for Thought programs turn schools into hubs that provide fresh food for their community and equip students with high-demand technical skills. Our comprehensive curriculum teaches coding, engineering fundamentals, plant science, and food justice.
            </p>

            <div className="space-y-6">
              {features.map((feature, index) =>
              <FeatureItem key={index} {...feature} />
              )}
            </div>
          </div>

          <div className="relative">
            <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-brand-lg">
              <AppImage
                src="/assets/images/Screenshot_2026-02-12_at_9.34.41_AM-1770906886181.png"
                alt="Hydroponic tower system with Coming Fall 2026 text showing innovative vertical farming technology for educational programs"
                fill
                className="object-cover" />

            </div>

            <div className="absolute -bottom-6 -left-6 bg-brand-primary text-brand-primary-foreground p-6 rounded-xl shadow-brand-lg max-w-xs">
              <div className="text-4xl font-bold mb-2">28-Week</div>
              <div className="text-sm font-medium">
                Flexible curriculum with add-on modules for comprehensive learning
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default ProgramOverview;